import { render, staticRenderFns } from "./NewsFloating.vue?vue&type=template&id=0fa1c3b8&scoped=true"
import script from "./NewsFloating.vue?vue&type=script&lang=js"
export * from "./NewsFloating.vue?vue&type=script&lang=js"
import style0 from "./NewsFloating.vue?vue&type=style&index=0&id=0fa1c3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1c3b8",
  null
  
)

export default component.exports